import Footer from "../../components/footer/footer"

export default Footer
